<template>
<div id="app">
<body class="d-flex flex-column h-100" id="home" v-if="this.$route.path !== '/login'">
    <footer class="footer mt-auto py-1 text-center">
        <div>
            <span>	©2019 EYGM Limited |  All rights reserved. </span>
        </div>
    </footer>
    </body>
    </div>
</template>

<script>
export default {
  name: 'Footer'
};
</script>